<div class="content">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_TASK_MANAGER_ACCOUNT.GENERAL.TITLE' | translate }}
  </div>
</div>
